import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import React, { useState } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
// Ensure this is correctly imported
import PaymentDetailsServices from "services/PaymentDetailsServices";
import ViewModal from "components/modal/ViewPaymentDetails";
import ViewOrderModal from "components/modal/ViewOrderDetails";
import Tooltip from "@mui/material/Tooltip";
import { FiEye } from "react-icons/fi";
const PaymentDetailsTable = ({
  paymentdetails,
  data,
  perpage,
  currentPage,
  tab,
}) => {
  const { handleViewOrder } = useToggleDrawer();

  const [, setError] = useState("");
  const [, setLoading] = useState(true);
  const [, setSelectedData] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [paymentOrderDetails, setPaymentOrderDetails] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const handleClick = (data) => {
    setSelectedData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setPaymentDetails();
  };

  const fetchPaymentDetails = async (id) => {
    try {
      let response;
      response = await PaymentDetailsServices.getallIdPayment(id);
      setPaymentDetails(response.data);
      setShowModal(true);
    } catch (err) {
      setError("Failed to load payment details.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderDetails = async (id) => {
    try {
      let response;
      response = await PaymentDetailsServices.getPaymentByOrder(id);
      setPaymentOrderDetails(response.data);
    } catch (err) {
      setError("Failed to load payment details.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <ViewModal
        isOpen={showModal}
        title="Payment Details"
        data={paymentDetails}
        onClose={closeModal}
      />

      <ViewOrderModal title="Order Details" data={paymentOrderDetails} />
      <TableBody>
        {paymentdetails
          .slice((currentPage - 1) * perpage, currentPage * perpage)
          .map((data, index) => (
            <TableRow key={data.id}>
              <TableCell className="text-sm text-center">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.agent_ref_no}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.ref_no}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.customer_name}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.order_id}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.payment_id}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.amount}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.invoice_number}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.is_recharge}
              </TableCell>

              <TableCell>
                <span
                  className={`text-sm text-center rounded-md 
                 ${
                   data.transaction_status === "debit"
                     ? "text-red-500"
                     : data.transaction_status === "credit"
                     ? "text-green-500"
                     : "text-gray-500"
                 }`}
                >
                  {data.transaction_status}
                </span>
              </TableCell>
              <TableCell>
                <span
                  className={`text-sm text-center rounded-md 
                 ${
                   data.payment_status === "Payment Successful"
                     ? "text-green-500"
                     : data.payment_status === "Payment Failure"
                     ? "text-red-500"
                     : data.payment_status === "Signature Invalid"
                     ? "text-yellow-500"
                     : "text-gray-500"
                 }`}
                >
                  {data.payment_status}
                </span>
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.current_balance}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data.previous_balance}
              </TableCell>

              <TableCell>
                <span className="text-sm">
                  {`${String(new Date(data.added_date).getDate()).padStart(
                    2,
                    "0"
                  )}-${String(
                    new Date(data.added_date).getMonth() + 1
                  ).padStart(2, "0")}-${new Date(
                    data.added_date
                  ).getFullYear()}`}
                </span>
              </TableCell>
              {tab !== 1 && (
                <TableCell>
                  
                  <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600 flex">
                  <Tooltip title="Payment Details" className="text-center flex flex-col gap-4">
                    {data.payment_id && (
                      <button
                        onClick={() => {
                          fetchPaymentDetails(data.payment_id);
                          handleClick();
                        }}
                        className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                      >
                        <FiEye />
                      </button>
                    )}
                    </Tooltip>
                    <Tooltip title="Order Details" className="text-center flex flex-col gap-4">
                    {data.order_id && (
                      <button
                        onClick={() => {
                          fetchOrderDetails(data.order_id);
                          handleViewOrder();
                        }}
                        className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                      >
                        <FiEye />
                      </button>
                    )}
                    </Tooltip>
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default PaymentDetailsTable;
